import { render, staticRenderFns } from "./resolveImages.vue?vue&type=template&id=4a70d744"
import script from "./resolveImages.vue?vue&type=script&lang=js"
export * from "./resolveImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports